import React from 'react';
import classnames from 'classnames';
import './banner.scss';

const lastItem = 4;

const Banner = ({ rounded = false, className }: { rounded?: boolean; className?: string }) => (
  <div className={`starter-guide-banner ${className}`}>
    {[1, 2, 3, 4].map((item) => {
      const conditionalClasses = { 'starter-guide-banner__item--rounded': false };
      if (item === lastItem) {
        conditionalClasses['starter-guide-banner__item--rounded'] = rounded;
      }
      const bannerClasses = classnames(
        `starter-guide-banner__item--${item}`,
        'starter-guide-banner__item',
        conditionalClasses,
      );
      return <div key={item} className={bannerClasses} />;
    })}
  </div>
);

export default Banner;
